import {
  constantRoutes,
  resetRouter,
  supervisionDecision,
  appointmentRemoval,
  voteOfPeople,
  meetingManagement,
  commentsHandle,
  representativeService,
  representativeStation,
  ruralNPC,
  auditRelease,
  systemManagement
} from '@/router'

import store from '../index'
import { deepClone } from '@/utils/index'

const state = {
  MenuCode: 'SY',
  routers: [],
  addRoutes: []
}

const mutations = {
  SET_MENUCODE: (state, MenuCode) => {
    state.MenuCode = MenuCode
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routers = constantRoutes.concat(...routes)
  }
}

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission (roles, route) {
  if (route.meta && route.meta.roles) {
    const roleList = route.meta.roles.filter(item => roles.indexOf(item) !== -1)
    return roleList.length > 0
  }
  if (route.children.length > 0 && route.children[0].meta && route.children[0].meta.roles) {
    const roleList = route.children[0].meta.roles.filter(item => roles.indexOf(item) !== -1)
    return roleList.length > 0
  }
  return false
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes (routes, roles) {
  const res = []
  routes.forEach((route) => {
    if (hasPermission(roles, route)) {
      if (route.children) {
        route.children = filterAsyncRoutes(route.children, roles)
      }
      if (!route.children || route.children.length) {
        res.push(route)
      }
    }
  })
  return res
}

const actions = {
  setMenuCode ({
    commit
  }, MenuCode) {
    commit('SET_MENUCODE', MenuCode)
  },
  generateRoutes ({
    commit
  }, MenuCode) {
    return new Promise((resolve) => {
      let accessedRoutes,
        button
      const menuList = store.getters.permissions || []
      if (MenuCode) {
        button = MenuCode
      }
      let dynamicButton
      const localButton = JSON.parse(localStorage.getItem('latestAsyncRouteName'))

      if (localButton && !button) {
        dynamicButton = localButton
      } else {
        dynamicButton = button
      }
      resetRouter()

      switch (dynamicButton) {
        case 'SY':
          accessedRoutes = ''
          break
        case 'JDJD':
          accessedRoutes = deepClone(supervisionDecision)
          break
        case 'RSRM':
          accessedRoutes = deepClone(appointmentRemoval)
          break
        case 'RDPJ':
          accessedRoutes = deepClone(voteOfPeople)
          break
        case 'HYGL':
          accessedRoutes = deepClone(meetingManagement)
          break
        case 'YJBL':
          accessedRoutes = deepClone(commentsHandle)
          break
        case 'DBFW':
          accessedRoutes = deepClone(representativeService)
          break
        case 'DBJZ':
          accessedRoutes = deepClone(representativeStation)
          break
        case 'XZRD':
          accessedRoutes = deepClone(ruralNPC)
          break
        case 'SHFB':
          accessedRoutes = deepClone(auditRelease)
          break
        case 'XTGL':
          accessedRoutes = deepClone(systemManagement)
          break
        default:
          accessedRoutes = []
          break
      }
      if (button) {
        localStorage.setItem('latestAsyncRouteName', JSON.stringify(button))
      }

      // 获取当前账号权限
      const roleList = []
      menuList.forEach((item) => {
        roleList.push(item.code)
        const childList = item.childList || []
        childList.forEach((items) => {
          roleList.push(items.code)
        })
      })
      commit('SET_ROUTES', filterAsyncRoutes(accessedRoutes, roleList))
      resolve(filterAsyncRoutes(accessedRoutes, roleList))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
